/**
 * Mirrors the `content-length-range` condition on the backend's presigned POST
 * policy (`getPresignedPost` in the backend's `@packages/storage`). The cap is
 * enforced by S3, not here — this exists so error copy can name a real number.
 * Keep in sync if the backend policy changes.
 */
export const MAX_IMAGE_UPLOAD_BYTES = 10 * 1024 * 1024;

/**
 * Renders a byte count the way the copy reads it, e.g. `10 MB`. Used on the cap
 * S3 reports back rather than only on the constant above, so the number an admin
 * sees is the one that actually rejected their file.
 */
export const formatUploadSizeLabel = (bytes: number): string => {
  const mb = bytes / (1024 * 1024);
  return `${Number.isInteger(mb) ? mb : mb.toFixed(1)} MB`;
};

/** Human-readable form of {@link MAX_IMAGE_UPLOAD_BYTES}, used when S3 doesn't tell us. */
export const MAX_IMAGE_UPLOAD_LABEL = formatUploadSizeLabel(
  MAX_IMAGE_UPLOAD_BYTES,
);

/**
 * Formats we point admins at when a file is rejected. The picker accepts any
 * `image/*` the browser can decode, so this is safe guidance rather than an
 * exhaustive list. Format names are proper nouns and stay untranslated — the
 * surrounding sentence and any conjunction belong to the lokalise string.
 */
export const SUPPORTED_IMAGE_TYPES_LABEL = "JPEG, PNG";
